import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap/lib';
import Api from './../../Global/Modules/Api';

class SwitchTabs extends Component {
  constructor() {
    super();
    this.state = {
      Tab: 1,
      Content: '',
      Title: ''
    }
    this.handleSelect = this.handleSelect.bind(this);
  }
  rawMarkup() {
    var rawMarkup = this.state.Content
    return { __html: rawMarkup };
  }

  componentDidMount() {
    this.handleSelect(this.props.tab)
  }
  handleSelect(eventKey) {
    if (eventKey === undefined) {

    } else {
      if (this.state !== null && this.state.Tab !== eventKey) {
        this.setState({ Tab: eventKey })
      }
      var goodUrl = this.props.url.split("/").join("zxyz");
      const FETCH_URL = 'api/pages/' + goodUrl + "zyzztab" + eventKey;
      Api.GetApi(FETCH_URL).then(data => {
        this.setState({ Content: data.description });
      });
    }
  }
  render() {
    return (
      <div>
        <Tabs defaultActiveKey={1} id="uncontrolled-tab-example" onSelect={this.handleSelect} >
          <Tab eventKey={1} title="Basiseisen">
            <p dangerouslySetInnerHTML={this.rawMarkup()}>
            </p>
          </Tab>
          <Tab eventKey={2} title="Eisen kennis">
            <p dangerouslySetInnerHTML={this.rawMarkup()}>
            </p>
          </Tab>
          <Tab eventKey={3} title="Eisen werkervaring">
            <p dangerouslySetInnerHTML={this.rawMarkup()}>
            </p>
          </Tab>
          <Tab eventKey={4} title="Overgangsregeling">
            <p dangerouslySetInnerHTML={this.rawMarkup()}>
            </p>
          </Tab>
          <Tab eventKey={5} title="Herinschrijving">
            <p dangerouslySetInnerHTML={this.rawMarkup()}>
            </p>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default SwitchTabs;



// WEBPACK FOOTER //
// ./src/components/Global/Modules/Tabs.js